import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowbackNopadding = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "data-name": "icon/arrowback/nopadding", viewBox: "0 0 10 15", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m18.916 4.281.908.908-6.5 6.5 6.5 6.5-.908.908-6.95-6.957-.434-.454.434-.454z", "data-name": "Path 1660", transform: "translate(-10.405 -4.091)", fill: "#cbd4dd" }));
const ForwardRef = forwardRef(SvgIconArrowbackNopadding);
export { ForwardRef as ReactComponent };
